// Import Hero section component
import Hero from "../components/Hero";
// Import image assets
import HeroImage from "../../assets/images/AboutUs.png";
import logo from "../../assets/images/Logo-light 1.png";
import service1 from "../../assets/images//Homepage 2.png";
import service2 from "../../assets/images/Homepage 3.png";
import service3 from "../../assets/images/Homepage 4.png";
// Import navigation and button components
import { useNavigate } from "react-router-dom";
import Button from "../components/Button";
// Import CSS for landing page styling
import "../../css/LandingPage.css";

/**
 * AboutUs page component for displaying company background and values.
 *
 * Sections:
 * - Hero section: Title, background image, and call-to-action button
 * - Photo credit overlay
 * - Company description and values
 */
const AboutUs = () => {
  const navigate = useNavigate();
  return (
    <div className="landing-page">
      {/* Hero section with title and background image */}
      <div style={{ position: "relative" }}>
        <Hero
          title={"About Us"}
          // subtitle can be enabled if needed
          backgroundImage={HeroImage}
          titleAlign="center"
          subtitleAlign="center"
          buttonText="BOOK A CONSULTATION"
          onButtonClick={() => {
            navigate("/contact");
          }}
        />
        {/* Photo credit overlay at the bottom right */}
        <div
          style={{
            position: "absolute",
            right: 0,
            bottom: 0,
            background: "#E1E1E180",
            color: "#000",
            padding: "0.3rem 1rem",
            textAlign: "left",
            zIndex: 2,
          }}
          className="content-tiny"
        >
          Photo Credit: BBA Photography, Shutterstock
        </div>
      </div>
      {/* Company description and values section */}
      <div
        className="footer footer-legal "
        style={{
          padding: "2rem 1rem",
          gap: "1rem",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <div className="content-large">
          <strong>
            Oakmont Financial Services is part of one of the largest Independent
            Oakmont Financial Services is part of one of the largest Independent
            Mortgage and Financial Planning networks in the UK, providing access
            to a wide range of products and services that you may not be able to
            find on the high street.
          </strong>
        </div>
        <div className="content-large">
          With over 10 years of professional experience, Gurmeet Singh Kler set
          up Oakmont Financial Services, based in Kingston Upon Thames, to
          provide tailored specialist advice on mortgages, personal health
          protection, and equity release.
        </div>
        <div className="content-large">
          What sets Oakmont apart is our dedication to providing expert advice
          that’s actually suited to your needs.
        </div>
      </div>
    </div>
  );
};

// Export the AboutUs page as default
export default AboutUs;
